module.exports = __webpack_public_path__ + "static/img/img-nofound.1786686659715.png";